import * as Sentry from '@sentry/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import ErrorFallback from './components/ErrorFallback'
import { initSentry, setDisplayContext } from './lib/sentry'
import { isParamError, parseDisplayParams } from './lib/params'
import './index.css'

initSentry()

const params = parseDisplayParams(window.location.search)
if (!isParamError(params)) setDisplayContext(params.placeId, params.userId)

const root = document.getElementById('root')
if (root) {
  createRoot(root).render(
    <StrictMode>
      <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
        <App />
      </Sentry.ErrorBoundary>
    </StrictMode>,
  )
}
